module.exports = __webpack_public_path__ + "img/environmentMonitoring.10ae5c10.svg";